export default __webpack_public_path__ + "static/media/25_ChengShiu.bc7c41ba.png";